import { AccountFilterStoreService } from '../../../../../core/store/account.filters.store.service';
import { Component, Output, EventEmitter, Input, OnInit } from '@angular/core';

@Component({
  selector: 'ccc-cca-users-filter',
  templateUrl: './users-filter.component.html',
  styleUrls: ['./users-filter.component.scss']
})
export class AccountsFilterComponent implements OnInit {
  emailFilterText = '';
  nameFilterText = '';

  showInactive = false;

  ownership = false;
  deletedAt = false;

  @Output()
  filters = new EventEmitter<any>();
  @Input() ownedByOrg = true;
  @Input() clearFieldsFilters: EventEmitter<boolean>;
  @Input() checkInactive: boolean;

  constructor(private accountFilter: AccountFilterStoreService) { }

  ngOnInit() {
    if (this.clearFieldsFilters) {
      this.clearFieldsFilters.subscribe((runFieldCleaning: boolean) => {
        if (runFieldCleaning) {
          this.clearNameFilter();
          this.clearEmailFilter();
        }
      });
    }
  }

  //  FILTERS
  onKeyUpEmail(textToFilter: string) {
    this.emailFilterText = textToFilter;
    this.accountFilter.emailFilter.next(textToFilter);
  }
  onKeyUpName(textToFilter: string) {
    this.nameFilterText =  textToFilter;
    this.accountFilter.nameFilter.next(textToFilter);
  }

  onChange(checked: boolean) {
    this.showInactive = checked;
    this.getAccountsWithFilter();
  }

  onChangeOwnership(checked: boolean) {
    this.ownership = checked;
    this.getAccountsWithFilter();
  }

  onChangeDeleted(checked: boolean) {
    this.deletedAt = checked;
    this.getAccountsWithFilter();

  }

  clearNameFilter() {
    this.nameFilterText = '';
    this.onKeyUpName('');

  }
  clearEmailFilter() {
    this.emailFilterText = '';
    this.onKeyUpEmail('');

  }

  getAccountsWithFilter() {
    const filters: any = {};

    if (this.showInactive) {
      filters.showInactive = this.showInactive;
    }

    if (this.ownership) {
      filters.ownership = this.ownership;
    }

    if (this.deletedAt) {
      filters.deletedAt = this.deletedAt;
    }

    this.filters.emit(filters);
  }
}
